
import { Component, Mixins } from "vue-property-decorator";
import { FixedPhraseEditDialogOptions } from "../../fixedPhrase/dialogs";
import { CommonComponentsAccessibleMixin } from "../../editor/mixins";
import { AiSyntaxDialog } from "../dialogs";

@Component
export default class AiFixedPhraseSelectorMixin extends Mixins(CommonComponentsAccessibleMixin) {
  $refs!: {
    editSyntaxDialog: AiSyntaxDialog[],
  };

  data(): any {
    return {
      dialogKey: 0,
      dialogKeys: [],
    };
  }
  dialogKey: number;
  dialogKeys: number[];

  get aiFixedPhraseOptions(): FixedPhraseEditDialogOptions {
    return {
      phrase: {
        description: [
          "AIが生成する文章の定型文テンプレートです。",
          "診療録の記載内容からAIに推論してほしい内容をキーワードとして埋め込んでください。",
          "キーワードは{}で囲んで指定してください。*の有無で改行の扱いが変わります。",
          "{キーワード}だと推論結果に含まれる改行を除去します。{*キーワード}だと改行を除去しません。",
          "例: {入院日}に当科入院され、{手術日}に{執刀医}執刀で{術式}を、{再手術日}に{再手術術式}を施行しました。",
        ].join("\r\n"),
        test: (text) => this.showAiPhraseDialog(text),
        createSyntax: (defaultKeyword) => this.createSyntax(defaultKeyword),
        editPreprocess: (text) => this.editPreprocess(text),
        createCommentSyntax: (text) => this.createCommentSyntax(text),
      }
    };
  }

  private async showAiPhraseDialog(text: string): Promise<void> {
    await this.commonComponents.dialogs.aiPhrase.show({
      template: text,
      actions: {},
      title: "文章生成テスト",
    });
  }

  private async createSyntax(defaultKeyword: string): Promise<string> {
    return this.commonComponents.dialogs.aiSyntax.show(defaultKeyword, this.editSyntax);
  }

  private async editSyntax(text: string): Promise<string> {
    this.dialogKey = this.dialogKey + 1;
    this.dialogKeys.push(this.dialogKey);
    await this.$nextTick();
    return this.$refs.editSyntaxDialog[this.$refs.editSyntaxDialog.length - 1].show(text, this.editSyntax);
  }

  onClose(key: number): void {
    this.dialogKeys = this.dialogKeys.filter(k => k !== key);
  }

  private async editPreprocess(text: string): Promise<string> {
    return this.commonComponents.dialogs.aiPreprocess.show(text);
  }

  private createCommentSyntax(text: string): string {
    return "{ comment ? { " + text + " } }";
  }
}
